import { Panel } from '@hologram-dimension/panel';
import { PanelNotification } from '@hologram-dimension/panel-notification';
import { OrganizationProvider, TagManager } from '@hologram-hyper-dashboard/components';
import { getUserContextDataMemoized } from 'common-js/api/util';
import { SIM_INVENTORY } from 'common-js/constants/paths';
import { useAppDispatch, useAppSelector } from 'common-js/hooks';
import { getTags as loadTags } from 'common-js/reducers/deviceFilter/actions';
import { getTags } from 'common-js/reducers/deviceFilter/selectors';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useFormContext } from 'react-hook-form';

const Tags = () => {
  const { setValue, getValues } = useFormContext();

  const tags = useAppSelector(getTags);
  const dispatch = useAppDispatch();

  const [loading, setLoading] = useState(true);

  const defaultTags = getValues('tags.tags');
  const defaultSelection = useMemo(() => defaultTags.map((tag) => tag.id), [defaultTags]);

  const userContext = useAppSelector(getUserContextDataMemoized);
  const orgId = userContext.isInOrgContext ? userContext.orgId : userContext.userOrgId;

  useEffect(() => {
    const fetchTags = async () => {
      await dispatch(loadTags());
      setLoading(false);
    };
    fetchTags();
  }, [dispatch]);

  const onToggleCheckbox = useCallback(
    (newTags: Array<TagId>) => {
      const newTagsSet = new Set(newTags);
      setValue(
        'tags.tags',
        tags.filter((tag) => newTagsSet.has(tag.id))
      );
    },
    [setValue, tags]
  );

  if (loading) {
    return <PanelNotification>Loading...</PanelNotification>;
  }

  return (
    <OrganizationProvider organizationId={orgId}>
      <div className="ActivationTagsStep">
        <Panel header="Tags">
          <TagManager
            className="ActivationTags"
            onTagSelectionChanged={onToggleCheckbox}
            simInventoryBaseUrl={SIM_INVENTORY}
            tagSelectMode
            defaultSelection={defaultSelection}
          />
        </Panel>
      </div>
    </OrganizationProvider>
  );
};

export default Tags;
